<template>
    <div class="beta-gate">
        <brand-backdrop />

        <div class="beta-gate-content">
            <div class="beta-gate-badge">
                <span class="beta-gate-glow"></span>
                <span class="beta-gate-icon">
                    <v-icon size="44" color="primary">mdi-lock-outline</v-icon>
                </span>
            </div>

            <div class="beta-gate-title">{{ $t('common.beta_restricted_title') }}</div>

            <div class="beta-gate-message">
                <v-icon size="18" color="primary" class="mr-2 mt-1">mdi-information-outline</v-icon>
                <div>{{ $t('common.beta_restricted_message') }}</div>
            </div>

            <logout-button large block outlined class="beta-gate-btn" />
        </div>
    </div>
</template>

<script>

import scrollLock from '@/mixins/scrollLock'
import BrandBackdrop from '@/components/common/BrandBackdrop'
import LogoutButton from '@/components/common/inputs/LogoutButton'

export default {
    name: 'BetaGate',
    components: {
        BrandBackdrop,
        LogoutButton,
    },
    mixins: [scrollLock],
}
</script>

<style scoped>

.beta-gate {
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06080C;
    padding: calc(40px + var(--safe-area-inset-top, 0px)) 24px calc(40px + var(--safe-area-inset-bottom, 0px));
    overflow-x: hidden;
    overflow-y: auto;
}

.beta-gate-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: beta-gate-fade-up .5s ease both;
}

.beta-gate-badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;
    animation: beta-gate-pop .6s cubic-bezier(.34, 1.56, .64, 1) both;
    animation-delay: .12s;
}

.beta-gate-glow {
    position: absolute;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(204, 255, 51, 0.22) 0%, rgba(204, 255, 51, 0.08) 45%, transparent 70%);
    filter: blur(8px);
}

.beta-gate-icon {
    position: relative;
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background: rgba(204, 255, 51, 0.1);
    border: 1px solid rgba(204, 255, 51, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.beta-gate-title {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: #F2F5FA;
}

.beta-gate-message {
    display: flex;
    align-items: flex-start;
    text-align: left;
    width: 100%;
    margin-top: 18px;
    padding: 14px 16px;
    border-radius: 14px;
    background: rgba(204, 255, 51, 0.06);
    border: 1px solid rgba(204, 255, 51, 0.2);
    color: rgba(242, 245, 250, 0.78);
    font-size: 14px;
    line-height: 1.5;
}

.beta-gate-btn {
    margin-top: 28px;
}

@keyframes beta-gate-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
}

@keyframes beta-gate-pop {
    0% { opacity: 0; transform: scale(.7); }
    60% { transform: scale(1.06); }
    100% { opacity: 1; transform: scale(1); }
}

</style>
